// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7a3fb80146--container--mI_26","info-block":"_7a3fb80146--info-block--IBTIf","link":"_7a3fb80146--link--aTPhh"};